import { Injectable } from '@angular/core';
import { PartnerPending } from './partner-pending.model';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

export interface PartnerPendingState extends EntityState<PartnerPending> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'partner-pending', idKey: 'TicketKey' })
export class PartnerPendingStore extends EntityStore<PartnerPendingState> {
  constructor() {
    super();
  }
}
